module.exports = __webpack_public_path__ + "static/media/graduation-cap.159c0da2.svg";